import * as React from 'react';
import Calendar from '../model/Calendar';
import { CalendarMode, default as Moleskine } from './calendar/Moleskine';
import { CalendarProps, Popover } from 'antd';

import Event from '../model/Event';
import EventStatusIcon from './icons/EventStatusIcon';
import DNSSECAccreditationIcon from './icons/DNSSECAccreditationIcon';
import AccreditationIcon from './icons/AccreditationIcon';
import MediaQuery from 'react-responsive';

import Flex from './StyledComponents/Flex';
import { isNullOrUndefined } from '../utils';
import { useTranslation } from '@nic-react-i18n/core';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';

export interface AgendaProps {
    agenda: Calendar;
    mode: CalendarMode;
    selectHandler: (date: dayjs.Dayjs) => void;
    value: dayjs.Dayjs;
    baseURI?: string;
    requestCalendar: boolean;
    title?: React.ReactElement<any>;
}

const fillEvents = (component: Array<React.ReactNode>, elem: object, viewKind: string) => {
    let format: string = (viewKind === 'year' ? 'dd DD' : 'HH:mm');

    //console.log('FillEvents: ', elem)

    Object.keys(elem).forEach((key: string, i: number) => {
        //console.log('Elem key: ', key)

        if (key !== 'length') {

            let evtArray: Array<Event> = (elem as any)[key];
            let len = evtArray.length;

            //console.log('Event Array: ', evtArray, len)

            let event: Event;
            for (let e = 0; e < len; e++) {

                event = evtArray[e];

              //  console.log('TestDate: event: ', event)

                let date = event.testDate.format('DDMMYYYY');
                component.push(
                    <Flex
                        direction={'row'}
                        justify={'space-between'}
                        align={'center'}
                        style={{
                            fontSize: 'lower',
                        }}
                        key={`${date}-${e}-${i}.${key}`}
                    >
                        <Flex
                            direction={'row'}
                            align={'center'}
                            justify={'space-around'}
                        >
                            <div style={{marginRight: '5px'}}>
                                {(event.type === 'dnssec' ?
                                        <DNSSECAccreditationIcon size={'1.3rem'} /> :
                                        <AccreditationIcon size={'1.3rem'} color={'orange'}/>
                                )}
                            </div>

                            <div style={{marginRight: '5px'}}>
                                <EventStatusIcon status={event.status}/>
                            </div>

                            <div style={{fontWeight: 800, marginRight: '5px'}}>{event.registrar}</div>

                        </Flex>

                        <div>{event.testDate.format(format)}</div>
                    </Flex>

                );
            }
        }
    });
};

const Agenda: React.FC<AgendaProps> = (props) => {
    const {locale} = useTranslation()
    const navigate = useNavigate()
    const renderBookingsTooltip = (elem: any, viewKind: CalendarMode ) => {

        let component: Array<React.ReactNode> = [];
        switch (viewKind) {
            case 'year': {

                Object.keys(elem).forEach((key: string, i: number) => {

                    if (key !== 'length') {
                        let element = elem[key];
                        fillEvents(component, element, viewKind);
                    }
                });

                break;
            }
            case 'month': {
                fillEvents(component, elem, viewKind);
                break;
            }
            default:
                break;

        }
        //  console.log('Tooltip LEN :', component.length);
        return (
            <div
                style={{
                    maxHeight: '40vh',
                    overflowY: 'auto',
                    paddingLeft: '10px',
                    paddingRight: '10px'
                }}
            >
                <Flex
                    direction={'column'}
                >
                    {component}
                </Flex>
            </div>
        );
    }

    const monthEventsRender =
        (date: dayjs.Dayjs, full: boolean, iconWidth: string, badgeWidth: string, showBackgroud?: boolean) => {

            const {agenda} = props;

            let planner = agenda.eventsTable;
            let hasBackground: boolean = (!isNullOrUndefined(showBackgroud) ? (showBackgroud ?? false) : false);
            let res = null;
            let component = null;
            if (planner[date.year()] &&
                planner[date.year()][date.month() + 1] &&
                planner[date.year()][date.month() + 1].length > 0) {
                if (full) {
                    component = (
                        <span className="fa-layers fa-fw" >
                            <i className="fal fa-calendar-check"/>
                            <span className="fa-layers-counter" style={{background: 'Tomato', fontSize: badgeWidth}}>
                                 {planner[date.year()][date.month() + 1].length}
                            </span>
                        </span>
                    );
                } else {
                    let style: React.CSSProperties = (hasBackground ? {
                        fontSize: iconWidth,
                        background: 'Tomato',
                        color: 'white',
                        borderRadius: '50%',
                        paddingLeft: '8px',
                        paddingRight: '8px',
                        textAlign: 'center'
                    } : {
                        fontSize: iconWidth,
                        color: 'Tomato',
                        textAlign: 'center'
                    });
                    component = (
                        <div
                            style={style}
                        >
                            {planner[date.year()][date.month() + 1].length}
                        </div>
                    );
                }
                let elem = planner[date.year()][date.month() + 1];
                let title = date.format('MMMM YYYY');
                res = (
                    <Popover
                        title={`${title}`}
                        content={renderBookingsTooltip(elem, props.mode)}
                    >
                        <div
                            className="notes-month"
                            style={{fontSize: iconWidth, color: 'lightgray', display: 'flex', justifyContent: 'center'}}
                            onClick={() => {
                                //console.log('click Year: ', title, elem, date.year(), date.month()+1)
                                navigate(`/bookings/calendar/month/${date.year()}/${date.month()+1}`)
                            }}
                        >
                            {component}
                        </div>
                    </Popover>
                );
            }
            return res;
    }

    const monthCellRender = (date: dayjs.Dayjs) => {
        return (
            <span>
                <MediaQuery minWidth={900}>
                    {monthEventsRender(date, true, '1.5vw', '2.5vw')}
                </MediaQuery>
                <MediaQuery minWidth={700} maxWidth={899}>
                    {monthEventsRender(date, true, '3vw', '5vw')}
                </MediaQuery>
                <MediaQuery minWidth={580} maxWidth={699}>
                    {monthEventsRender(date, false, '4vw', '6vw', true)}
                </MediaQuery>
                <MediaQuery minWidth={300} maxWidth={579}>
                    {monthEventsRender(date, false, '4vw', '6vw')}
                </MediaQuery>
            </span>
        );
    }

    const dateEventsRenderer =
        (date: dayjs.Dayjs, full: boolean, iconWidth: string, badgeWidth: string, showBackgroud?: boolean) => {
            const {agenda} = props;

            let planner = agenda.eventsTable;
            let hasBackground: boolean = (!isNullOrUndefined(showBackgroud) ? (showBackgroud ?? false) : false);

            let res = null;
            let component = null;
            // this.renderBookingsTooltip(date, this.props.mode);
            if (planner[date.year()] &&
                planner[date.year()][date.month() + 1] &&
                planner[date.year()][date.month() + 1][date.date()] &&
                planner[date.year()][date.month() + 1][date.date()].length > 0) {
                if (full) {
                    component = (
                        <span className="fa-layers fa-fw" >
                            <i className="fal fa-calendar-check"/>
                            <span className="fa-layers-counter" style={{background: 'Tomato', fontSize: badgeWidth}}>
                                {planner[date.year()][date.month() + 1][date.date()].length}
                            </span>
                        </span>
                    );
                } else {
                    let style: React.CSSProperties = (hasBackground ? {
                        fontSize: iconWidth,
                        background: 'Tomato',
                        color: 'white',
                        borderRadius: '50%',
                        paddingLeft: '8px',
                        paddingRight: '8px',
                        textAlign: 'center'
                    } : {
                        fontSize: iconWidth,
                        color: 'Tomato',
                        textAlign: 'center'
                    });
                    component = (
                        <div
                            style={style}
                        >
                            {planner[date.year()][date.month() + 1][date.date()].length}
                        </div>
                    );
                }

                let elem = planner[date.year()][date.month() + 1][date.date()];
                let title = date.format('dddd DD MMMM YYYY');
                res = (
                    <Popover
                        style={{height: '20vh', }}
                        title={`${title}`}
                        content={renderBookingsTooltip(elem, props.mode)}
                    >
                        <div
                            className="notes-month"
                            style={{fontSize: iconWidth, color: 'lightgray', display: 'flex', justifyContent: 'center'}}
                            onClick={() => {
                                //console.log('click Year: ', title, elem, date.year(), date.month()+1, date.date())
                                navigate(`/bookings/calendar/day/${date.year()}/${date.month()+1}/${date.date()}`)
                            }}
                        >
                            {component}
                        </div>
                    </Popover>
                );
            }
            return res;
        }

    const dateCellRender: CalendarProps<dayjs.Dayjs>['fullCellRender'] = (date, info) => {
        //console.log('Agenda q qqdateCellRender: ', info)
        return (
            <span>
                <MediaQuery minWidth={900}>
                    {dateEventsRenderer(date, true, '2vw', '2.5vw')}
                </MediaQuery>
                <MediaQuery minWidth={700} maxWidth={899}>
                    {dateEventsRenderer(date, true, '3vw', '5vw')}
                </MediaQuery>
                <MediaQuery minWidth={580} maxWidth={699}>
                    {dateEventsRenderer(date, false, '4vw', '6vw', true)}
                </MediaQuery>
                <MediaQuery minWidth={300} maxWidth={579}>
                    {dateEventsRenderer(date, false, '4vw', '6vw')}
                </MediaQuery>
            </span>
        );
    }

    const panelChangeHandler = (date?: dayjs.Dayjs, mode?: CalendarMode): void => {
        // console.log("panelChangeHandler: Date: ", date, " mode ", mode);
    }

        const {agenda, mode, value, selectHandler, baseURI, requestCalendar, title} = props;


        //console.log('Agenda: ', agenda, mode, value)

        return (
            <Moleskine
                title={title}
                locale={locale}
                mode={mode}
                date={value}
                agenda={agenda}
                prefixCls="ant-picker-calendar"
                fullscreen={true}
                onSelect={selectHandler}
                dateCellRender={dateCellRender}
                dateFullCellRender={dateCellRender}
                monthCellRender={monthCellRender}
                monthFullCellRender={monthCellRender}
                onPanelChange={panelChangeHandler}
                baseURI={baseURI}
                requestCalendar={requestCalendar}
            />
        )

}

export default Agenda